const allowedOriginsRegx = /^https:\/\/((?!xn--)[a-zA-Z0-9-]+\.)*(codametrix\.com|codametrix\.ai)(:\d+)?(\/.*)?$/;

/**
 * Validate if origin is allowed and as per same-origin policy
 * @param origin , pass origin
 * return true if origin is valid
 */
export const isValidTargetOrigin = (origin: string) => {
  if (!origin) {
    return false;
  }
  const allowLocalhost = true;

  try {
    const url = new URL(origin);
    const { protocol, hostname } = url;
    // validate protocol
    if (protocol !== 'http:' && protocol !== 'https:') {
      return false;
    }

    // check if origin is localhost
    if (
      allowLocalhost &&
      (hostname === 'localhost' || hostname === '127.0.0.1')
    ) {
      return true;
    }

    // to validate if call is coming from allowed domains only
    return allowedOriginsRegx.test(origin);
  } catch {
    return false;
  }
};
